export default __webpack_public_path__ + "static/media/no-records.67512a93.png";